import { browserHistory } from 'react-router';
import { USER_SELECTED_MODELLINE, GET_ALL_MODELLINES, GET_ALL_MODELLINES_FAILED, GET_ALL_MODELLINES_SUCCEEDED } from '../constants';
import { getAllModelLines } from '../../services';
import { getVehicleByModelLineCode } from '../selectors/models'


/**
 * Action to retrieve All Model Lines from the service
 * @param channel - ni or in
 * @param lang - en or es
 * @returns {function(*)}
 */
export function getAllModellinesAction() {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: GET_ALL_MODELLINES
    });
    getAllModelLines(state).then((result) => {
      dispatch({
        type: GET_ALL_MODELLINES_SUCCEEDED,
        result
      });
    })
      .catch((error) => {
        dispatch({
          type: GET_ALL_MODELLINES_FAILED,
          error
        });
      });
  };
}

export function modelLineSelectedAction(modelLineCode, context) {
  return (dispatch, getState) => {
    const state = getState();
    const vehicle = getVehicleByModelLineCode(state, modelLineCode);
    if (!vehicle) {
      return;
    }
    const slug = vehicle.slug;
    dispatch({
      type: USER_SELECTED_MODELLINE,
      modelLineCode,
      context,
      modelSlug: slug
    });
    const landingPage = state.config.landingPage || '';
    const redirect = `${landingPage}/${slug}${window.location.search}`;
    browserHistory.push(redirect);
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/modelline.js
 **/